import batchCategoriesUpsert from "./batch-categories-upsert-route";
import getCategoriesRoute from "./get-categories-route";
import getSubcategoriesRoute from "./get-subcategories-route";
import getSubcategorySkillsRoute from "./get-subcategory-skills-route";

export default {
  "batch-categories-upsert": batchCategoriesUpsert,
  "get-categories": getCategoriesRoute,
  "get-subcategories": getSubcategoriesRoute,
  "get-subcategory-skills": getSubcategorySkillsRoute,
};
